import { memo } from 'react';

import { FloatingCommentForm } from '~/components/AnnotationsV2/shared/FloatingCommentForm';
import { usePublicSubmitNewDiscussion } from '~/swr-hooks/discussions/usePublicSubmitNewDiscussion';

/**
 * The public asset modals' floating comment form — binds the share-link discussion submission
 * around the shared form body. The Public* visualizer wrappers supply it to the annotations
 * tree's FloatingCommentForm prop.
 */
export const PublicFloatingCommentForm = memo(() => {
  const { submitNewDiscussion } = usePublicSubmitNewDiscussion();

  return <FloatingCommentForm onSubmitNewDiscussion={submitNewDiscussion} />;
});

PublicFloatingCommentForm.displayName = 'PublicFloatingCommentForm';
